import React from 'react';
import './Contact.css';

const Contact = () => {
    return (
        <div id="contact">
            <h1 className="fs-1 text-center my-5">Contact Us</h1>
            <div className="contact-container">
                <div className="contact">
                    <h1 className="fs-3 my-5">Send Us A Message</h1>
                    <input className="mb-3 px-2" type="text" placeholder="Your Name" />
                    <input className="mb-3 px-2"  type="text" placeholder="Email Address" /><br />
                    <input className="mb-3 px-2" type="text" placeholder="Phone Number" />
                    <input className="mb-3 px-2" type="text" placeholder="Subject" /><br />
                    <textarea className="px-2" name="" id="" cols="30" rows="7" placeholder="Your Message"></textarea>
                    <button className="button mt-5">Send Message</button>
                </div>
                <div>
                    <h3 className="my-5">Contact Details</h3>
                    <h5 className="my-5"><i className="addressIcon fas fa-home"></i> Phone: 01725385909</h5>
                    <h5 className="my-5"><i className="addressIcon fas fa-envelope"></i> Email: mdawladbdinfo@gmail.com</h5>
                    <h5 className="my-5"><i className="addressIcon fas fa-map-marker-alt"></i> Address: 29 Division Pt <br /> <br /> New York, NY 10002, USA</h5>
                </div>
            </div>
        </div>
    );
};

export default Contact;